// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__eiNcb","navbar__item":"navbar_navbar__item__Z4GLB"};